export const TAB_QUERY_PARAM = 'panel';

export const CONNECTION_TAB_KEY = 'connection';
export const REVIEWS_TAB_KEY = 'reviews';
export const RESPONSE_SETTINGS_TAB_KEY = 'response-settings';
export const MEDIA_TAB_KEY = 'media';
export const BUSINESS_INFO_TAB_KEY = 'business-info';
